import { Button } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import streamToolsQueue from '../../helpers/queue';
import usePreventReload from '../../hooks/usePreventReload';

const StreamToolsGoLiveButton = ({
  streamToolsUnitsList,
  unit,
  goLiveDisableForStreamtools,
  goLive,
  t,
  handleSRTCondition,
  isLanguageRuOrFr,
  openStopStreamModal,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [_, setShowExitPrompt] = usePreventReload(false);
  const dispatch = useDispatch();
  const StreamtoolsGoLive = async (unit) => {
    setShowExitPrompt(true);
    await dispatch(streamToolsQueue(goLive, [unit, handleSRTCondition]));
    setShowExitPrompt(false);
  };

  const isStreaming =
    streamToolsUnitsList?.[unit.BOSSID]?.isStreamtoolsStreaming;
  const loading = streamToolsUnitsList?.[unit.BOSSID]?.progress > 0;

  const button = (
    <Button
      loading={loading}
      className={[
        'btn',
        isStreaming ? 'btn-danger' : 'btn-primary',
        isLanguageRuOrFr ? 'ru-ant-btn' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      disabled={!isStreaming && goLiveDisableForStreamtools}
      //no disability if streaming started
      type='button'
      size='large'
      style={{
        color: '#fff',
        backgroundColor: isStreaming ? '#dc3545' : '',
      }}
      onClick={() => {
        if (!isStreaming) {
          StreamtoolsGoLive(unit);
        } else {
          openStopStreamModal();
        }
      }}
    >
      {isStreaming ? t('STOP') : t('GOLIVE')}
    </Button>
  );

  return button;
};

export default StreamToolsGoLiveButton;
